import { getAPIData, getAPIDataParams, postApi } from 'app/utils/apiFunction';
import React from 'react';
import { Card, CircularProgress, IconButton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { getAPIDataParamsReturn } from 'app/utils/apiFunction';
import ControlledTextField from 'app/components/ControlledTextField';
import { SelectTextFieldNew } from 'app/components/SelectTextField';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import SubmitButtonDisplayer from 'app/components/SubmitButtonDisplayer';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { RequestGraphData } from '../../../../adalConfig';





const FridgeNotifications = (props) => {
    const [fridges, setFridges] = React.useState([]);
    const [notifications, setNotifications] = React.useState(props.notifications);
    const [operations, setOperations] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [completed, setCompleted] = React.useState(false);
    const Swal = useSwalWrapper();

    React.useEffect(() => {
        getAPIDataParamsReturn('/Warehouses/Get', {}).then((whs) => {
            var promArr = [];
            var factorys = whs.filter((wh) => { return wh.isFactory });
            for (var i = 0; i < factorys.length; i++) {
                promArr.push(getAPIDataParamsReturn('/Warehouses/GetFridges', {
                    WarehouseId: factorys[i].id,
                }));
            }
            Promise.all(promArr).then((res) => {
                setFridges(res.reduce((p, c) => [...p, ...c], []));
            });
        });
        getAPIData('/Notifications/GetOperations', (res) => {
            setOperations(res);
        });
        
    }, []);

    const updateFunction = (key, index, getId) => {
        return (value) => {
            setNotifications((prev) => {
                const newNotifications = [...prev];
                if (index !== -1) {
                    newNotifications[index][key] = getId ? value.id : value;
                }

                return newNotifications;
            });
        };
    }
    const addNotification = () => {
        setNotifications((prev) => {
            return [...prev, { Id: 0, key: '', field: '', operatorId: '', value: '', repeats: 1, FunctionId: props.functionId, Group: props.functionId, emailBool: true, mobileBool: false }];
        });
    }
    const removeNotification = (index) => {
        setNotifications((prev) => {
            const newNotifications = [...prev];
            newNotifications.splice(index, 1);
            return newNotifications;
        });
    }
    const validate = () => {
        var warningMessages = [];
        var errorMessages = [];

        for (var i = 0; i < notifications.length; i++) {
            var n = notifications[i];
            if (!(n.repeats > 0 && n.repeats < 21)) {
                errorMessages.push('Repeats must be between 1 and 20');
            }
        }


        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }
        if (errorMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',

            });
        } else if (warningMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(warningMessages),
                icon: 'warning',
                title: 'Oops...',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'No, I\'ll edit it',

            }).then(result => {
                if (result.value) {
                    props.submit(props.notifications, notifications).then((res) => {
                        setLoading(false);
                        setError(null);
                    });
                } else if (result.dismiss === Swal.DismissReason.cancel) {

                }
            });
        } else {
            props.submit(props.notifications, notifications).then((res) => {
                setLoading(false);
                setError(null);
            });
        }
        setLoading(true);



    }
    console.log('notifications', notifications);
    
    return (
        <Grid container spacing={2}  >
            {notifications.length > 0 ? notifications.map((n, index) => {
                return (
                    <Grid item xs={12} key={index + 'a'}>
                        {/* Fridge */}
                        <SelectTextFieldNew style={{ minWidth: '150px' }} key={'si1' + index} title="Fridge" checkID={n.key} nameFunc={(f) => (f.name)} valueFunc={v => v?.id} list={fridges} setState={updateFunction('key', index, true)} disabled={props.disabled} />
                        {/* Field */}
                        <SelectTextFieldNew style={{ minWidth: '150px' }} key={'si2' + index} title="Field" state={n.field} nameFunc={(f) => (f)} valueFunc={v => v} list={['Temperature']} setState={updateFunction('field', index, false)} disabled={props.disabled} />
                        {/* Operation */}
                        <SelectTextFieldNew style={{ minWidth: '150px' }} key={'si3' + index} title="Operator" checkID={n.operatorId} nameFunc={(f) => (f.description)} valueFunc={v => v?.id} list={operations} setState={updateFunction('operatorId', index, true)} disabled={props.disabled} />
                        {/* Value */}
                        <ControlledTextField key={'bg' + index} title="Value" state={n.value} setState={updateFunction('value', index, false)} disabled={props.disabled} />
                        {/* repeats */}
                        <ControlledTextField key={'bgr' + index} title="Repeats (1-20) " state={n.repeats} setState={updateFunction('repeats', index, false)} disabled={props.disabled} number />
                        {/* Checkbox */}
                        <FormControlLabel
                            label={"Email"}
                            style={{ marginLeft: '20px' }}
                            control={
                                <Checkbox
                                    checked={notifications[index].emailBool}
                                    onChange={(event) => { updateFunction('emailBool', index, false)(event.target.checked) }}
                                />
                            }
                        />
                        <FormControlLabel
                            label={"SMS"}
                            control={
                                <Checkbox
                                    checked={notifications[index].mobileBool}
                                    onChange={(event) => { updateFunction('mobileBool', index, false)(event.target.checked) }}
                                />
                            }
                        />
                        {/* Teams */}
                        <SelectTextFieldNew style={{ minWidth: '150px' }} key={'fdfssi3' + index} title="Teams chat" checkID={n.teamsChatId} nameFunc={(f) => (f.topic)} valueFunc={v => v?.id} list={props.teamsChats} setState={updateFunction('teamsChatId', index, true)} disabled={props.disabled} />
                        {/* Remove Button */}
                        <IconButton key={'si4' + index} onClick={() => { removeNotification(index) }} disabled={props.disabled}>
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                );
            }) : null}
            <Grid item xs={12} key={'ssa'}>
                <IconButton key={'sisadlo5'} onClick={() => { addNotification() }} disabled={props.disabled}>
                    <AddIcon />
                </IconButton>
            </Grid>
            <Grid item xs={12} key={'ssa112sa'}>
                <SubmitButtonDisplayer error={error} completed={completed} loading={loading} allowed={true} submitFunc={validate} handleClose={() => 1} />

            </Grid>
        </Grid>
    );
};

export default FridgeNotifications;
